import { defaultAxios, IParams } from './base';

export interface IMutateMonthlyRequestInsert extends IParams {
  custSeq: string;
  hopeDay?: number; // 202330324 희망일 받지 않음
  agreeYn: string;
}

export const mutateMonthlyRequestInsert = (
  params: IMutateMonthlyRequestInsert,
) => {
  return defaultAxios().post(`/loan/MonthlyRequest/insert`, params);
};
